'use strict';

module.exports = [require('./algebra'), require('./arithmetic'), require('./bitwise'), require('./combinatorics'), require('./complex'), require('./geometry'), require('./logical'), require('./matrix'), require('./probability'), require('./relational'), require('./set'), require('./special'), require('./statistics'), require('./string'), require('./trigonometry'), require('./unit'), require('./utils')];


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/index.js
// module id = 1074
// module chunks = 0